import environment from '@environment';
import { MakePaymentPayloadDTO, PaymentStatusDTO } from 'core/models/account/make-payment-payload.dto';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { PaymentService } from 'core/stores/payment/interfaces/payment-service';

export interface PayAtTokenizeResponse {
  tokenPaymentUrl: string
  [key: string]: any
}
export interface PayAtRedirectResponse {
  webPaymentLinks: PayAtOption[];
  [key: string]: any
}

export interface PayAtOption {
  paymentMethodName: "CARD" | "CAPITEC_EFT" | "TEST_WEB_ovQfHewrjy" | "EFT",
  paymentUrl: string
}

export class PayAtPaymentService implements PaymentService<MakePaymentPayloadDTO> {
  public canStatusPoll = false;
  public canRefetchPoll = false;
  public canTimeoutPoll = false;

  private apiBuilder = new EndpointHelper(`${environment.UTILITY_API_URI}/payat`);

  MakePayment(requestBody?: Partial<MakePaymentPayloadDTO>): Promise<PayAtOption[]> {
    const url = this.apiBuilder.createUrl('initiate')
      .addRouteParam('full')
      .build();

    return HttpClient.GetInstance.post<unknown, PayAtRedirectResponse>(url, requestBody)
      .then(
        (res) => {
          const response = res?.data;
          return response?.webPaymentLinks;
        },
        err => {
          console.error('Failed request', err);
          return Promise.reject(err);
        });
  }

  TokenLinks(requestBody?: any) {
    const url = this.apiBuilder.createUrl('token')
      .addRouteParam('paymentLink')
      .build();

    return HttpClient.GetInstance.post<unknown, PayAtTokenizeResponse>(url, requestBody)
      .then(
        (res) => {
          const response = res?.data;
          return {
            redirectUrl: response.tokenPaymentUrl,
            transactionId: response.referenceKey,
            paymentType: `${response.responseCode}`
          }
        },
        err => {
          console.error('Failed request', err);
          return Promise.reject(err);
        });
  }

  PaymentStatus(country: string, orderId: string): Promise<PaymentStatusDTO> {
    return Promise.reject(`PayAtPaymentService -> PaymentStatus not implemented`);
  }

  RefetchPayment() {
    return Promise.reject('PayAtPaymentService -> RefetchPayment Not Implemented')
  }
}